<template>
  <div class="text-center">
  		<div class="border border-primary rounded-circle text-primary">
        <font-awesome-icon icon="exclamation" class="fa-4x" />
        <font-awesome-icon icon="credit-card" class="fa-5x" />
  		</div>
  		<br>
  		<h3>Sorry, An error has ocurred while processing your payment.</h3>
  		<h4>Please try again.</h4>
  		<br>
  		<div class="btn-group text-center" role="group" >
	        <router-link to="/" class="btn btn-primary">TRY AGAIN</router-link>
      </div>
  </div>
</template>

<script>
export default {
  name: 'PaypalError',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.border{
		border-width: 5px !important;
		width: 200px;
		height: 200px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-around;
		flex-direction: row;
	}
</style>
